import axios from "axios";

export const sendprofileImage = async (file, employeeData) => {
  const formData = new FormData();
  formData.append('profileImage', file);
  debugger
  // Add employeeData to formData under 'afiliado' object
  formData.append('afiliado', JSON.stringify(employeeData));
  const url = window.location.hostname.includes('localhost')  ? 'localhost' : 'unioninformatica.org';

  const config = {
    method: "POST",
    url: `http://${url}:4000/api/v1/boletaDigital/uploadPhotoAfiliado`,
    //url: "http://localhost:4000/api/v1/boletaDigital/uploadPhotoAfiliado",
    data: formData,
  };

  try {
    const response = axios(config);
    
    return await response;
  } catch (error) {
    const { response } = error;
    return await response;
  }
};
